import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

const SignupPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="signup-page" className="min-h-screen bg-ff-bg flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" className="font-serif italic text-3xl text-ff-text">Freddy Fiction</Link>
          <p className="text-ff-text-muted text-sm mt-3 font-light">Create your account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="label text-ff-text-muted mb-1.5 block">NAME</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="signup-name"
              className="input-dark w-full"
              placeholder="Optional"
            />
          </div>
          <div>
            <label className="label text-ff-text-muted mb-1.5 block">EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="signup-email"
              className="input-dark w-full"
              required
              autoFocus
            />
          </div>
          <div>
            <label className="label text-ff-text-muted mb-1.5 block">PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="signup-password"
              className="input-dark w-full"
              required
              minLength={6}
              placeholder="At least 6 characters"
            />
          </div>

          {error && (
            <p data-testid="signup-error" className="text-red-400 text-sm text-center">{error}</p>
          )}

          <button
            type="submit"
            data-testid="signup-submit"
            disabled={loading}
            className="btn-primary w-full disabled:opacity-50"
          >
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>

        <p className="text-center text-ff-text-muted text-sm mt-8">
          Already have an account?{" "}
          <Link to="/login" state={{ from }} data-testid="signup-login-link" className="text-ff-accent hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;
